import React, { useCallback, useState } from "react";
import CardTemplate from "../CardTemplate";
import styled from "styled-components";
import {
	ChairpersonData,
	CoChairData,
} from "hooks/ConsultantDashboard/useConsultantDashboardData";
import { ViewCoHostModal } from "../HostHubActivity/ViewCoHostModal";
import { disableScrolling, enableScrolling } from "utils/ToggleScrolling";

interface Props {
	chairpersonData: ChairpersonData;
	coChairData: CoChairData;
	afterOneYear: boolean;
	logins: number;
}

const HostHubActivity = ({
	chairpersonData,
	coChairData,
	afterOneYear,
	logins,
}: Props) => {
	const [openViewCoHostModal, setOpenViewCoHostModal] = useState(false);

	//Call when you close a modal to update styles on aem side.
	const handleCloseModalOnAEM = useCallback(() => {
		window.parent.postMessage("closeModal", window.location.origin);
		document.documentElement.classList.remove("bookfairs-modal--open");
		enableScrolling();
	}, []);

	//Call when you open a modal to update styles on aem side.
	const handleOpenModalOnAEM = () => {
		window.parent.postMessage("openModal", window.location.origin);
		document.documentElement.classList.add("bookfairs-modal--open");
		disableScrolling();
	};

	const handleClickViewCoHostModal = () => {
		setOpenViewCoHostModal(true);
		handleOpenModalOnAEM();
	};

	const handleEnterKeyPress = (e: React.KeyboardEvent) => {
		if (e.key === "Enter") {
			handleClickViewCoHostModal();
		}
	};

	return (
		<>
			{openViewCoHostModal && (
				<ViewCoHostModal
					closeModal={() => {
						setOpenViewCoHostModal(false);
						handleCloseModalOnAEM();
					}}
					coHostNameList={coChairData.map((entry) => entry.name)}
				/>
			)}
			<CardTemplate
				title="Host Hub Activity"
				linkText={`Host: ${chairpersonData.name}`}
			>
				<OuterContainer>
					<InnerContainer>
						<NumberCaption>Host login</NumberCaption>
						<StyledNumber>{logins}</StyledNumber>
					</InnerContainer>
					<InnerContainer>
						{!afterOneYear && (
							<>
								<NumberCaption>
									Co-host with Host Hub access
								</NumberCaption>
								<StyledNumber>
									{coChairData.length}
								</StyledNumber>
								<RedTextLink
									tabIndex={1}
									onClick={() => {
										handleClickViewCoHostModal();
									}}
									onKeyDown={(e) => handleEnterKeyPress(e)}
								>
									View co-hosts
								</RedTextLink>
							</>
						)}
					</InnerContainer>
				</OuterContainer>
			</CardTemplate>
		</>
	);
};

export const StyledNumber = styled.div`
	font-weight: 900;
	font-size: 36px;
	line-height: 36px;
`;

export const NumberCaption = styled.div`
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 19px;
`;

const OuterContainer = styled.div`
	display: flex;
	justify-content: left;
	column-gap: 180px;
	row-gap: 16px;
	flex-wrap: wrap;
`;

const InnerContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

const RedTextLink = styled.div`
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	color: #e81111;
	display: inline;
	margin-top: 8px;
	text-decoration: none;
	&:hover {
		font-style: unset;
		text-decoration: underline;
		cursor: pointer;
	}
	&:focus-visible {
		outline: 2px solid #e81111;
		color: #e81111;
		outline-offset: 1px;
		margin-top: 1px;
	}
`;

export default HostHubActivity;
